<template>
    <div style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)">
        <el-form ref="form" :model="form2" label-width="180px">
            <el-form-item label="微信官方通道" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="经营描述：">{{business_description}}</el-form-item>
            <el-form-item label="经营行业：">{{business_sector}}</el-form-item>
            <el-form-item label="法人银行卡："><div v-if="industry_license !== ''" ><img :src= "getImgUrl1()"  @click="previewPic(industry_license)"   style="width: 300px;height: 200px; "/></div></el-form-item>
            <el-form-item label="开户名称：">{{account_name}}</el-form-item>
            <el-form-item label="开户总行名称：">{{deposit_bank}}</el-form-item>
            <el-form-item label="开户银行账号：">{{bank_account}}</el-form-item>
            <el-form-item label="开户支行所在地：">{{account_city}}</el-form-item>
            <el-form-item label="开户行银行全称（包括支行）：">{{bank_branch}}</el-form-item>
            <el-form-item label="特殊资质："><div v-if="special_qualification !== ''" ><img :src= "getImgUrl2()"  @click="previewPic(special_qualification)"   style="width: 300px;height: 200px; "/></div></el-form-item>

        </el-form>

        <el-form ref="form" :model="form3" label-width="180px">
            <el-form-item label="微信进件状态" class="grid-content bg-purple-dark">
            </el-form-item>
            <el-form-item label="进件时间：">{{jj_dates}}</el-form-item>
            <el-form-item label="小微商户号：">{{sub_mchid}}</el-form-item>
            <el-form-item label="进件状态：">{{applyment_state}}</el-form-item>
            <el-form-item label="描述：">{{applyment_state_msg}}</el-form-item>
            <el-form-item label="入驻签约链接："><div v-if="sign_url !== ''" ><img :src= "getImgUrl3()"  @click="previewPic(sign_url)"   style="width: 200px;height: 200px; "/></div></el-form-item>

        </el-form>

         <!-- 图片预览 -->

              <el-dialog :visible.sync="dialogVisible" :modal="false" title="图片预览" width="50%">

                <img :src="previewpic" alt=""  width="100%" />

                <span slot="footer" class="dialog-footer">

              <el-button type="primary" @click="dialogVisible = false">确 定</el-button>

            </span>

              </el-dialog>

          <!-- 图片预览 -->

    </div>


</template>
<style>

    .bg-purple-dark {
        background: #e5e9f2;
    }
</style>
<script>
    import * as agentService from "@/api/sys/agent";
    import util from '@/libs/util.js'
    export default {
        name: "child2",
        props: ["agentid_f2"],
        components: { },
        data() {
            return {
                industry_license:'',
                business_description:'',
                business_sector:'',
                account_name:'',
                deposit_bank:'',
                bank_account:'',
                account_city:'',
                bank_branch:'',
                dialogVisible: false,

                previewpic: "",
                special_qualification:'',
                loading: false,
                oneagent: {},
                form2: {},
                form3: {},
                jj_dates:'',
                sub_mchid:'',
                applyment_state:'',
                applyment_state_msg:'',
                sign_url:'',
                editFormVisible: false
            };
        },
        watch: {
            agentid_f2(val) {
                console.log("###########");
                this.getTableData();
            }
        } ,
        mounted() {
            this.getTableData();
        },
        methods: {
            getImgUrl1(){
                return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+this.industry_license;
            },getImgUrl2(){
                return "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+this.special_qualification;
            },getImgUrl3(){
                return this.sign_url;
            },
            previewPic(item) {

                this.previewpic =  "https://hfqy-1315629620.cos.ap-chengdu.myqcloud.com/"+item;

                this.dialogVisible = true;

            },

            getTableData() {
                var formData4 = new FormData() // 声明一个FormData对象
                formData4.append("agentid",this.agentid_f2);
                agentService.getPerfectAgent(formData4).then(data => {
                    if(data!=null && data!=""){



                        this.business_description=data.business_description;
                        this.business_sector=data.business_sector;
                        this.industry_license=data.industry_license;
                        this.account_name=data.account_name;
                        this.deposit_bank=data.deposit_bank;
                        this.bank_account=data.bank_account;
                        this.account_city=data.account_city;
                        this.bank_branch=data.bank_branch;
                        this.special_qualification=data.special_qualification;
                            if(data.jj_dates!=null && data.jj_dates!=""){
                           this.jj_dates=data.jj_dates;
                            }else{
                                this.jj_dates="";
                            }
                        if(data.sub_mchid!=null && data.sub_mchid!=""){
                            this.sub_mchid=data.sub_mchid;
                        }else{
                            this.sub_mchid="";
                        }
                        if(data.applyment_state!=null && data.applyment_state!=""){
                            this.applyment_state=data.applyment_state;
                        }else{
                            this.applyment_state="";
                        }
                        if(data.applyment_state_msg!=null && data.applyment_state_msg!=""){
                            this.applyment_state_msg=data.applyment_state_msg;
                        }else{
                            this.applyment_state_msg="";
                        }
                        if(data.sign_url!=null && data.sign_url!=""){
                            this.sign_url=data.sign_url;
                        }else{
                            this.sign_url="";
                        }

                    }
                });
            }
        }
    };
</script>
